import React, { useState, useEffect } from 'react'
import './NavigationData.css';
import * as signalR from "@microsoft/signalr";
import { Button } from 'react-bootstrap';
import { logger } from '../../utils/logger';

function NavigationData({drone}){
    const [hubTelemNav, setHubTelemNav] = useState(hubNavConnect);
    const [updateTelemFromHub, setUpdateTelemFromHub] = useState(null);

    const [telemetry, setTelemetry] = useState([]);
    const [currentTelemetry, setCurrentTelemetry] = useState({imei: 0, batteryRemaining: -1, height: 0, speed: 0, sputniksCount: 0});

    useEffect(() => {
        return () => {
            logger.debug("NavigationData unmount");
            hubTelemNav.stop();
        };
    }, []);

    useEffect(() => {
        setTelem(updateTelemFromHub);
        
    }, [updateTelemFromHub]);

    useEffect(() => {
        switchTelemetry();
        //logger.debug("switch telemetry");
    }, [drone]);

    function switchTelemetry() {
        if(drone === null) {
            return;
        }

        setCurrentTelemetry(telemetry.find((item) => item.imei === drone.imei));
        /*
        const itemExists = telemetry.some((item) => item.imei === drone.imei);

        if(telemetry) {
            const telem = 
        }*/
    }

    function setTelem(msg) {
        setTelemetry((telems) => {
            const itemExists = telems.some((item) => item.imei === msg.imei);
            if(itemExists) {
                return telems.map((t) =>
                    t.imei === msg.imei
                      //? { ...t, batteryRemaining: msg.batteryRemaining, height: msg.height, speed: msg.speed, sputniksCount: msg.sputniksCount }
                      ? { ...t, ...msg }
                      : t
                  )
            } else {
                //return [...telems, {imei: msg.imei, batteryRemaining: msg.batteryRemaining, height: msg.height, speed: msg.speed, sputniksCount: msg.sputniksCount}];
                return [...telems, { ...msg }];
            }
        });

        if(msg?.imei === drone?.imei) {
            setCurrentTelemetry(msg);
        }
    }

    function hubNavConnect(){
        const protocol = new signalR.JsonHubProtocol();
        let connection = new signalR.HubConnectionBuilder()
            .withUrl("api/drone-hub")
            .withAutomaticReconnect([0, 2000, 10000, 10000, 30000, 10000])
            .withHubProtocol(protocol)
            .build();;
        connection.on('Telemetry', (message) =>
        {
            setUpdateTelemFromHub(message);
        });

        connection.start();
        return connection;
    }



    return(
        <>
            {drone == null ? <></> : 
                <>
                    <div className='navigation-data'>
                        <div className='nav-box-left'><div className='nav-box-text addition-text'>ALT:</div> <div>{(currentTelemetry?.height ?? 0.0).toFixed(0)} m</div></div>
                        <div className='nav-box-right'><div className='nav-box-text addition-text'>SPD:</div> <div>{(currentTelemetry?.speed ?? 0.0).toFixed(1)} m/s</div></div>
                    </div>
                </>
            }
        </>
    )
}

export default NavigationData;